import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 引入全局配置和常量
import { TOKEN_PC_KEY, USER_ID_PC_KEY, NICK_NAME_PC_KEY, MY_AVATAR_PC_KEY, MY_SIGNATURE_PC_KEY } from './utils/constants'
import { msgError, msgSuccess, msgLoading, msgConfirm, msgClear } from './utils/modal'
import { formatDateText, formatDateAndTimeText, parseTime } from './utils/index';

// 引入去原生化的全局配置盲测同步机制与长连接常驻总线机制
import { ConfigLoader } from './utils/configLoader'
import { GlobalWsBus } from './utils/globalWs'

Vue.config.productionTip = false

Vue.prototype.TOKEN_PC_KEY = TOKEN_PC_KEY
Vue.prototype.USER_ID_PC_KEY = USER_ID_PC_KEY
Vue.prototype.NICK_NAME_PC_KEY = NICK_NAME_PC_KEY
Vue.prototype.MY_AVATAR_PC_KEY = MY_AVATAR_PC_KEY
Vue.prototype.MY_SIGNATURE_PC_KEY = MY_SIGNATURE_PC_KEY

Vue.prototype.msgError = msgError
Vue.prototype.msgSuccess = msgSuccess
Vue.prototype.msgLoading = msgLoading
Vue.prototype.msgConfirm = msgConfirm
Vue.prototype.msgClear = msgClear

Vue.prototype.formatDateText = formatDateText
Vue.prototype.formatDateAndTimeText = formatDateAndTimeText
Vue.prototype.parseTime = parseTime

/**
 * 【PC端核心前置路由免密拦截器】
 * 作用：锁死本地磁盘，只要 Token 还在，直接免密物理放行去往聊天主面板，防范反复登录
 */
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem(TOKEN_PC_KEY)

  if (to.path === '/login') {
    if (token) {
      next('/chat') // 💡 对标PC端：如果已登录，强行拦截登录页并送往 /chat 聊天主面板
    } else {
      next() // 未登录，放行去登录页
    }
  } else {
    if (token) {
      next() // 有 Token，100% 物理放行去往目标页
    } else {
      next('/login') // 全新未登录，无情踢回登录页
    }
  }
})

/**
 * 【PC端全局路由维活守护】
 * 作用：每次切换页面或刷新时，自动触发动态路由探测测速与长连接维活
 */
router.afterEach((to) => {
  // 如果用户已经登录，并且不是跳转登录页，强制在底层保持 Netty 管道长连接死锁锁定
  const token = localStorage.getItem(TOKEN_PC_KEY)
  if (token && to.path !== '/login') {
    GlobalWsBus.initWebSocketConnection()
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
